/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

let nodeList = `
034ea80f8b148c750463546bd999bf7321a0e6dfc60aaf84bd0400a2e8d376c0d5@hub-1.LNBiG.com:9735
033e9ce4e8f0e68f7db49ffb6b9eecc10605f3f3fcb3c630545887749ab515b9c7@hub-2.LNBiG.com:9735
02c91d6aa51aa940608b497b6beebcb1aec05be3c47704b682b3889424679ca490@hub-3.LNBiG.com:9735
`;

export default nodeList.split("\n").filter( word => word.length > 0).map(
    elem => {
	let f;
	if (( f = elem.match(/^([a-f0-9]+)@([^.]+)/)) !== null) {
	    return { nodeID: f[1], lndID: f[2], uri: elem, rand: Math.random() };
	}
	else {
	    throw new Error(`Invalid node URI: ${elem}`);
	}
    }
).sort( (a, b) => { return a.rand - b.rand } );
